export const SITE = {
  name: "Brainwave Solutions",
  url: "https://brainwavesolutions.net",
  email: "nate.parish@brainwavesolutions.net",
  phone: "",
  image: "https://brainwavesolutions.net/logo512.png",
  logo: "https://brainwavesolutions.net/assets/logo.svg",
  description:
    "Brainwave Solutions helps businesses and individuals improve spreadsheets, dashboards, reporting, automation, data cleanup, websites, and custom tools.",
  locality: "Burley",
  region: "ID",
  country: "US",
  founder: "Nate Parish",
  areaServed: "Worldwide",
};
